export const SERVER_URL = 'http://localhost:3001';
export const FIREBASE_URL = 'https://portfolio-gallery-f62a0-default-rtdb.europe-west1.firebasedatabase.app';
